/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _checkDevice = __webpack_require__(1);
	
	var _checkDevice2 = _interopRequireDefault(_checkDevice);
	
	var _menu = __webpack_require__(2);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _telLink = __webpack_require__(3);
	
	var _telLink2 = _interopRequireDefault(_telLink);
	
	var _accordion = __webpack_require__(4);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _smoothScroll = __webpack_require__(5);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	var _eqHeight = __webpack_require__(6);
	
	var _eqHeight2 = _interopRequireDefault(_eqHeight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.KUWAHARA = {};
	
	(function (window, document, $, undefined) {
	
	  KUWAHARA.device = new _checkDevice2.default($('.js-device'));
	
	  $(window).on('resize', function (e) {
	    KUWAHARA.device.resize();
	  });
	
	  $('.js-menu-open').each(function (i, el) {
	    new _menu2.default();
	  });
	
	  $('.js-tel').each(function (i, el) {
	    new _telLink2.default(el);
	  });
	
	  $('.js-accordion').each(function (i, el) {
	    new _accordion2.default(el);
	  });
	
	  $('.js-scroll').each(function (i, el) {
	    new _smoothScroll2.default(el);
	  });
	
	  $('.js-height').each(function (i, el) {
	    new _eqHeight2.default(el);
	  });
	})(window, document, jQuery);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CheckeDevice = function () {
	  function CheckeDevice(el) {
	    _classCallCheck(this, CheckeDevice);
	
	    this.element = $(el);
	    this.win = $(window);
	    this.timer = 200;
	    this.resize();
	    this.checkDevice();
	  }
	
	  _createClass(CheckeDevice, [{
	    key: 'checkDevice',
	    value: function checkDevice() {
	      this.device = this.element.is(':visible') ? 'sp' : 'pc';
	    }
	  }, {
	    key: 'resize',
	    value: function resize() {
	      var _this = this;
	
	      var t = false;
	      this.winWidth = this.win.width();
	      this.win.on('resize', function (e) {
	        var $this = $(e.currentTarget);
	        var currentWidth = $this.width();
	        if (_this.winWidth !== currentWidth) {
	          if (t !== false) {
	            clearTimeout(t);
	          }
	          t = setTimeout(function () {
	            _this.checkDevice();
	          }, _this.timer);
	        }
	      });
	    }
	  }]);
	
	  return CheckeDevice;
	}();
	
	exports.default = CheckeDevice;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Menu = function () {
	  function Menu(el) {
	    _classCallCheck(this, Menu);
	
	    this.openBtn = $('.js-menu-open');
	    this.closeBtn = $('.js-menu-close');
	    this.body = $('body');
	    this.openClass = 'is-nav-open';
	    this.event();
	  }
	
	  _createClass(Menu, [{
	    key: 'event',
	    value: function event() {
	      var _this = this;
	
	      this.openBtn.on('click', function (e) {
	        e.preventDefault();
	        var isNavOpen = _this.body.hasClass(_this.openClass);
	        if (isNavOpen) {
	          _this.close();
	        } else {
	          _this.show();
	        }
	      });
	
	      this.closeBtn.on('click', function (e) {
	        e.preventDefault();
	        _this.close();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.body.addClass(this.openClass);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.body.removeClass(this.openClass);
	    }
	  }]);
	
	  return Menu;
	}();
	
	exports.default = Menu;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TelLink = function () {
	  function TelLink(el) {
	    _classCallCheck(this, TelLink);
	
	    this.element = $(el);
	    this.openClass = 'is-open';
	    this.event();
	  }
	
	  _createClass(TelLink, [{
	    key: 'event',
	    value: function event() {
	      this.element.on('click', function (e) {
	        if (KUWAHARA.device.device === 'pc') {
	          e.preventDefault();
	        }
	      });
	    }
	  }]);
	
	  return TelLink;
	}();
	
	exports.default = TelLink;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Accordion = function () {
	  function Accordion(el) {
	    _classCallCheck(this, Accordion);
	
	    this.element = $(el);
	    this.btn = this.element.find('.js-accordion-btn');
	    this.body = this.element.find('.js-accordion-body');
	    this.openClass = 'is-open';
	    this.event();
	  }
	
	  _createClass(Accordion, [{
	    key: 'event',
	    value: function event() {
	      var _this = this;
	
	      this.btn.on('click', function (e) {
	        e.preventDefault();
	        var isOpen = _this.element.hasClass(_this.openClass);
	        if (isOpen) {
	          _this.close();
	        } else {
	          _this.open();
	        }
	      });
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      this.element.addClass(this.openClass);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.element.removeClass(this.openClass);
	    }
	  }]);
	
	  return Accordion;
	}();
	
	exports.default = Accordion;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SmoothScroll = function () {
	  function SmoothScroll(el) {
	    _classCallCheck(this, SmoothScroll);
	
	    this.element = $(el);
	    this.speed = 300;
	    this.event();
	  }
	
	  _createClass(SmoothScroll, [{
	    key: 'event',
	    value: function event() {
	      var _this = this;
	
	      this.element.on('click', function (e) {
	        e.preventDefault();
	        var href = _this.element.attr('href');
	        var $target = $(href);
	        if ($target.length !== 0) {
	          _this.moveTo(e, $target);
	        }
	      });
	    }
	  }, {
	    key: 'moveTo',
	    value: function moveTo(e, target) {
	      var offset = target.offset().top;
	      $('html, body').animate({ scrollTop: offset }, this.speed, 'swing');
	    }
	  }]);
	
	  return SmoothScroll;
	}();
	
	exports.default = SmoothScroll;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EqHeight = function () {
	  function EqHeight(el) {
	    _classCallCheck(this, EqHeight);
	
	    this.element = $(el);
	    this.item = this.element.find('.js-height-item');
	    this.group = this.element.attr('data-height-group');
	    this.event();
	  }
	
	  _createClass(EqHeight, [{
	    key: 'event',
	    value: function event() {
	      if (this.group === undefined) {
	        this.item.matchHeight();
	      } else {
	        var arr = this.group.split(',');
	        for (var i in arr) {
	          var $item = $('.' + arr[i]);
	          console.log($item);
	          this.element.find($item).matchHeight();
	        }
	      }
	    }
	  }]);
	
	  return EqHeight;
	}();
	
	exports.default = EqHeight;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// ../asset/js/common.js